import { Field } from 'formik'
import React from 'react'

import { Checkbox, CurrencyInput, Icon, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import {
  CurrentMonthSpending,
  type CurrentMonthSpendingProps,
} from '../CurrentMonthSpending/CurrentMonthSpending'
import * as S from './ChargeLimitFormGroup.styled'

type ChargeLimitFormGroupProps = {
  isEnabled: boolean
  limitEnabledFieldName?: string
  limitFieldName?: string
  currentMonthSpending?: CurrentMonthSpendingProps['value']
}

export const ChargeLimitFormGroup = ({
  isEnabled,
  limitEnabledFieldName = 'setChargeLimit',
  limitFieldName = 'chargeLimit',
  currentMonthSpending,
}: ChargeLimitFormGroupProps) => (
  <>
    <S.CheckboxContainer>
      <Field component={Checkbox} name={limitEnabledFieldName} label="Set a monthly charge limit" />
      <S.Tooltip>
        <Tooltip
          reference={<Icon component={QuestionMarkIcon} height={15} />}
          placement="top"
          fluid
        >
          This is the maximum amount your payment method will be charged during a calendar month
          (from 12AM UTC on the 1st of the month to 11:59PM UTC on the last day of the month).
        </Tooltip>
      </S.Tooltip>
    </S.CheckboxContainer>
    {isEnabled && (
      <S.ContentContainer>
        <S.CurrencyInputWrapper>
          <Field
            component={CurrencyInput}
            name={limitFieldName}
            label="Monthly charge limit"
            max={9_999_999.99}
          />
        </S.CurrencyInputWrapper>
        {currentMonthSpending && (
          <S.CurrentMonthSpendingWrapper>
            <CurrentMonthSpending value={currentMonthSpending} />
          </S.CurrentMonthSpendingWrapper>
        )}
      </S.ContentContainer>
    )}
  </>
)
